import { render, staticRenderFns } from "./SuffixesForm.vue?vue&type=template&id=cc4bd3dc&lang=pug"
import script from "./SuffixesForm.vue?vue&type=script&lang=js"
export * from "./SuffixesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports